import React, { useEffect, useState } from "react";

const GoogleAd = ({
  layout = "horizontal",
  slot = "1234567890",
}) => {
  const [adFailed, setAdFailed] = useState(false);

  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } else {
        // setAdFailed(true);
      }
    } catch (err) {
      console.error("Adsense Error:", err);
      // setAdFailed(true);
    }
  }, []);

  const adStyles = {
    horizontal: {
      display: "block",
      width: "100%",
      height: "90px",
      marginBottom: "20px",
      objectFit: "cover",
    },

    vertical: {
      display: "block",
      width: "300px",
      height: "600px",
      marginBottom: "20px",
      objectFit: "cover",
    },

    square: {
      display: "block",
      width: "300px",
      height: "300px",
      marginBottom: "20px",
      objectFit: "cover",
    },
  };

  const fallbackAds = {
    horizontal: [
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3",
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
    ],

    vertical: [
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3",
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
    ],

    square: [
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
      "https://images.unsplash.com/photo-1496171367470-9ed9a91ea931",
    ],
  };

  if (!adFailed) {
    return (
      <div>
        {fallbackAds[layout].map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Fallback Ad ${index + 1}`}
            style={adStyles[layout]}
          />
        ))}
      </div>
    );
  }

  return (
    <ins
      className="adsbygoogle"
      style={adStyles[layout]}
      data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default GoogleAd;